import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import StepWrapper from '../stepWrapper';
import { NewFlowBox } from './PersonalDetails';
import { TextInput } from '../../atoms/text-input/text-input';
import { validateString } from '../../../utils/form-validator';
import { loginUser } from '../../../redux/api-v2/UserApi';
import Success from '../../Lottie/success';
import Error from '../../Lottie/error';
import { StepFormWrapper } from '../../molecules/form-tab-presenter/form-tabStyles';
import { ContactBox } from '../../molecules/contact-box/contact-box';
import { Link } from 'react-router-dom';
import { SessionManager } from '../../../utils/session-manager';
import { Button } from '../../template/main-template/main-templateStyles';
import { useTranslation } from 'react-i18next';

const ExtensionFlow = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [documentId, setDocumentId] = useState<string>('');
  const [orderNumberError, setOrderNumberError] = useState(false);
  const [documentIdError, setDocumentIdError] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [apiError, setApiError] = useState(false);
  const loginApi = useAppSelector(state => state.user.login);

  useEffect(() => {
    if (loginApi.loading === 'succeeded' && loginApi.response) {
      setApiSuccess(true);
    } else if (loginApi.loading === 'failed') {
      setApiError(true);
    }
  }, [loginApi.loading, loginApi.response]);

  const validate = () => {
    const orderNumberIsValid = validateString(orderNumber);
    const documentIdIsValid = validateString(documentId);
    setOrderNumberError(!orderNumberIsValid);
    setDocumentIdError(!documentIdIsValid);
    return orderNumberIsValid && documentIdIsValid;
  };

  const handleContinue = () => {
    const isValid = validate();
    if (isValid) {
      dispatch(
        loginUser({
          orderNumber: orderNumber || undefined,
          documentId: documentId || undefined
        })
      );
    }
  };

  let content;
  switch (true) {
    case apiSuccess:
      content = (
        <StepFormWrapper $summary>
          <Success text={t('success-message-verification')} />
          <ContactBox icon={false} />
        </StepFormWrapper>
      );
      break;
    case apiError === true:
      content = (
        <StepFormWrapper $summary>
          <Error text={t('error-message-verification')} />
          <Link
            to='/onboarding?extendedInsurance=true'
            style={{ textAlign: 'center' }}
          >
            <Button
              id='ExtensionFlowError_button-back-to-extension-flow-start_Button'
              onClick={() => {
                SessionManager.setButtonId(
                  'ExtensionFlowError_button-back-to-extension-flow-start_Button'
                );
              }}
            >
              {t('BACK')}
            </Button>
          </Link>
        </StepFormWrapper>
      );
      break;
    default:
      content = (
        <StepWrapper next={{ f: handleContinue, label: 'NEXT' }}>
          <NewFlowBox>
            <TextInput
              field={{
                id: 'orderNumber-extension',
                type: 'string',
                mandatory: true
              }}
              onChange={setOrderNumber}
              value={orderNumber}
              warning={orderNumberError}
            />
            <TextInput
              field={{
                id: 'documentId-extension',
                type: 'string',
                mandatory: true
              }}
              onChange={setDocumentId}
              value={documentId}
              warning={documentIdError}
            />
          </NewFlowBox>
        </StepWrapper>
      );
  }

  return content;
};

export default ExtensionFlow;
